var _defs, _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _polygon2, _polygon3, _g2, _g3, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f9f9;}.cls-3{clip-path:url(#clip-path);}.cls-10,.cls-4{fill:#746f6f;}.cls-5,.cls-9{fill:#f07900;}.cls-6{fill:#525252;}.cls-7{clip-path:url(#clip-path-2);}.cls-8{clip-path:url(#clip-path-3);}.cls-10,.cls-9{fill-rule:evenodd;}.cls-11{fill:#dedede;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.25,
    y: 108.84,
    width: 60.17,
    height: 58.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 179.79,
    y: 108.96,
    width: 60.21,
    height: 57.92
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.42,
    y: 145.09,
    width: 56.42,
    height: 36.29
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FullConcept3_256x222") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.75,13.8c62.12-26.59,84.95-9,102.45,4.91s30.84,49.84,6.67,86-26.62,79.87-76.66,98.5S55,192.92,23,150.88-4.54,67.17,17.67,48.42,71.62,40.38,133.75,13.8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.88,152.29l-1.09.21-5.54,1.09v13.29H24.54c3.5,0,6.21-3.88,8-6.46.38-.54.71-1,1-1.46a99.23,99.23,0,0,1,8.21-8.79l1-1c.29-.29.58-.58.88-.83,3-2.92,3.12-3.5,2.08-4.79-.71-.88-1.21-.88-1.46-.88a7.77,7.77,0,0,0-3,1.13l-.75.37c-.75.38-4.54,2.83-7,4.46L28.63,152l1.25-5.83L31,140.84v-.09l0-.12c.5-1.59,2.17-2.71,4.55-3.71a.49.49,0,0,0,.33-.46l0-5.83a.47.47,0,0,0-.46-.46h-.17c-4.54,1.5-8.91,3-10.29,3.67-1.21,2.12-6.33,11.54-9.54,17.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.33,143.17c.25.37.55.75.84,1.12a2.5,2.5,0,0,0-.46-.7,2.45,2.45,0,0,0-.38-.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.58,119.42a4.21,4.21,0,1,1-4.2-4.25A4.2,4.2,0,0,1,57.58,119.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 53.38,
    cy: 156.34,
    rx: 4.21,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.83,108.84a.48.48,0,0,0-.5.5v29.12h0v4.25A11.91,11.91,0,0,1,39.5,142l1.21-.62V111.21H66.08v53.33H40.71v-9.87c-.79.79-1.58,1.62-2.38,2.46v9.29a.48.48,0,0,0,.5.46H68a.47.47,0,0,0,.46-.46V109.34a.47.47,0,0,0-.46-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.38,128.21a9.66,9.66,0,0,0-9.63,9.67,12,12,0,0,0,.29,2.41l.21,0a4.14,4.14,0,0,1,3.33,1.84c1.25,1.54,1.38,2.87.88,4.08a9.57,9.57,0,0,0,13.21-3.38,9.63,9.63,0,0,0-8.29-14.58Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 82.75,
    y: 94.59,
    width: 90.29,
    height: 9.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 88.37,
    y: 87.79,
    width: 79,
    height: 4.87
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 145.41,
    y: 55.09,
    width: 11.79,
    height: 30.79
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 122,
    y: 55.09,
    width: 11.79,
    height: 30.79
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 98.54,
    y: 55.09,
    width: 11.79,
    height: 30.79
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "143.33 34.05 143.08 34.46 136.33 46.17 135.79 47.13 120.08 47.13 119.54 46.17 112.79 34.46 112.5 33.96 88.37 48.3 88.37 53.17 167.37 53.17 167.37 48.3 143.33 34.05"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "121.17 21.75 114.42 33.5 121.17 45.21 134.66 45.21 140.54 34.96 123.37 34.96 125.21 38.17 133.96 38.17 132.29 41.13 123.54 41.13 119.12 33.5 123.54 25.84 132.29 25.84 135.83 32.01 140.54 32.01 134.66 21.75 121.17 21.75"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "125.21 28.8 123.33 32.01 132.46 32.01 130.58 28.8 125.21 28.8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.62,160.67l-29.71,6.21-29.75-6.21a.49.49,0,0,1-.37-.46V138.29a.47.47,0,0,1,.5-.45h.08L209.91,144l29.5-6.16a.54.54,0,0,1,.59.37v22a.49.49,0,0,1-.38.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.83,122.17a8.06,8.06,0,0,1,4.58,10.42A8,8,0,0,1,207,137.17a8,8,0,0,1,5.79-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197,120.84a3.56,3.56,0,0,1,2,4.54,3.51,3.51,0,0,1-6.55-2.54,3.46,3.46,0,0,1,4.55-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210,141.46l1.46-.29-26.25-10.25,7.34-19,42.2,16.46L231.41,137l2.79-.58,3.46-8.92a.48.48,0,0,0-.29-.62L191.54,109a.52.52,0,0,0-.63.29l-8.7,22.55a.48.48,0,0,0,.29.62l18,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223,138.54a4.28,4.28,0,0,0,.46.13l2.92-.63a3.33,3.33,0,0,0,1.21-1.7,3.51,3.51,0,1,0-4.59,2.2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.08,161.75H102.29v-1.58l5.29-6h6.5Zm-7.54-10.33L96.42,162.83v13.34h3.5a6.63,6.63,0,0,1,13.25,0h3.62V151.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.12,145.09v31.08h16.34a6.6,6.6,0,0,1,13.2,0h5.17V145.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M106.54,177.83a1.4,1.4,0,1,1,1.38-1.41,1.35,1.35,0,0,1-1.38,1.41Zm0-6.33a4.92,4.92,0,1,0,4.88,4.92A4.89,4.89,0,0,0,106.54,171.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M141,177.88a1.42,1.42,0,1,1,1.42-1.42,1.4,1.4,0,0,1-1.42,1.42Zm0-6.34a4.92,4.92,0,1,0,4.92,4.92A4.9,4.9,0,0,0,141,171.54Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M79.37,65.34,71,89.88,66,79.42a22.08,22.08,0,0,0-12.13,7.33c-5.12,6.25-7.58,15.38-7.58,15.38s-3.71-8.29.29-19.42a26.2,26.2,0,0,1,13.79-15L55.25,57.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.08,102.21,182,87.38l11.42-1.92a21.64,21.64,0,0,0-3.59-13.62c-4.5-6.67-12.58-11.54-12.58-11.54s9-1.25,18.54,5.66A26.12,26.12,0,0,1,206.2,83.34l11.5-2Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoPlaceholder);
export default __webpack_public_path__ + "static/media/promo-placeholder.e14e4f5abc4c936e334175bd22b88691.svg";
export { ForwardRef as ReactComponent };